// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"667":"6eaeea11","977":"cd768abd"}[chunkId] + ".chunk.js";
};